<template>
    <div class="searchList">
        <searchHeaderView class="header"></searchHeaderView>
        <div class="header-bg-div"></div>
        <el-input v-model="searchValue" class="search-input input-with-select">
            <el-select v-model="selectType" slot="prepend" placeholder="请选择">
                <el-option v-for="(item) of typeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
            </el-select>
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
            <!-- <i slot="suffix" class="el-icon-search search-icon" @click="search"></i> -->
        </el-input>
        <div class="content">
            <listView ref="listView"></listView>
		</div>
    </div>
</template>

<script>
import searchHeaderView from '../../components/main/searchHeaderView.vue'
import listView from './listView'

import { getQueryString } from '@/utils'

export default {
    components: {
        searchHeaderView,
        listView
    },
    data () {
        return {
            searchValue: '',
            selectType: 'keyWord',
            typeList: [
                // {
                //     key: 'all',
                //     value: '全部'
                // },
                // {
                //     key: 'base',
                //     value: '文献元数据'
                // },
                // {
                //     key: 'schema',
                //     value: '细粒度元数据'
                // },
                // {
                //     key: 'pic',
                //     value: '图表元数据'
                // },
                // {
                //     key: 'person',
                //     value: '人物'
                // },
                // {
                //     key: 'org',
                //     value: '机构'
                // },
                // {
                //     key: 'event',
                //     value: '事件'
                // },
                // {
                //     key: 'geo',
                //     value: '地理'
                // },
                // {
                //     key: 'topic',
                //     value: '专题'
                // },
                // {
                //     key: 'zuopin',
                //     value: '作品'
                // },
                // {
                //     key: 'shiwu',
                //     value: '实物'
                // }
                {
                    key: 'keyWord',
                    value: '标题'
                }, {
                    key: 'bookName',
                    value: '书籍名'
                }, {
                    key: 'classification',
                    value: '中图分类'
                }
            ],
            schemaType: '',
            keyWord: '',
            classification: '',
            bookName: '',
            structureType: ''
        }
    },
    mounted () {
        this.keyWord = getQueryString('keyWord') ? getQueryString('keyWord') : '';
        this.searchValue = this.keyWord;
        // this.search();
    },
    methods: {
        search () {
            // this.$refs.listView.getData();
            let query = {};
            query[this.selectType] = this.searchValue;
            let routeUrl = this.$router.resolve({
                name: 'searchList',
				query
            })
            window.location = routeUrl.href;
            location.reload();
        }
    }
};
</script>

<style lang='less' scoped>
@import "~@/styles/variables.less";
.searchList {
	width: 100%;
	height: auto;
    // background: rgb(244, 244, 244);

	.header {
		width: 100%;
		height: 80 * @uh;
		z-index: 10;
		background: rgba(248, 248, 248, 0.7);
		position: relative;
		color: #8d5e1a;
	}

	.header-bg-div {
		position: absolute;
		left: 0px;
		top: 0px;
		width: 1910 * @uw;
		height: 300 * @uh;
		background-image: url('~@/assets/images/main/header.jpg');
    	background-size: 100% 140%;
		z-index: 0;
	}

	.title {
		width: 520 * @uw;
		height: 40 * @uh;
		font-size: 40 * @uw;
		margin-left: 700 * @uw;
		position: relative;
		margin-top: 80 * @uh;
		color: #430a00;
	}

	.book-chart-div {
		width: 1200 * @uw;
		height: 482 * @uh;
		margin-top: 60 * @uh;
		margin-left: 360 * @uw;
		box-shadow: 0px 0px 10px 5px #e0e0e0;
	}

    .search-input {
        width: 40%;
        margin-left: 30%;
        margin-top: 80 * @uh;
        border: 1px solid rgb(126, 161, 172);
        border-radius: 5px;
    }

	.content {
		width: 100%;
		// height: auto;
		display: flex;
		justify-content: space-between;
		margin-left: 360 * @uw;
		margin-top: 110 * @uh;
        // background: rgb(244, 244, 244);
	}
}
// /deep/ .el-input__suffix {
// 	display: flex;
// 	align-items: center;
// 	// margin-right: -5px;
// 	border-radius: 5px;
// 	padding: 0px 30px 0px 30px;
// 	background: rgb(141,94,26);
//     cursor: pointer;
// }
/deep/ .el-input--suffix {
    width: 130 * @uw;
}
</style>
